import tippy from 'tippy.js';

class ComponentTooltip {
  constructor() {
    this._init();
  }

  _init() {
    tippy('.tooltip', {
      animation: false, // Désactive l'animation pour tester la réactivité brute
      duration: 0,
      appendTo: () => document.body,
    });
  }
}

export const componentTooltip = new ComponentTooltip();
